import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import BookCover from "@/components/BookCover";
import BookTagline from "@/components/BookTagline";
import { AMAZON_URL } from "@/content";

const BookFeature = () => (
  <section data-testid="book-feature-section" className="bg-cream border-t border-stone/60 relative overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute -top-24 -left-24 w-[420px] aspect-square rounded-full bg-[radial-gradient(circle,rgba(76,144,128,0.05),transparent_65%)] blur-2xl"
    />
    <div className="mx-auto max-w-6xl px-6 md:px-10 py-28 md:py-40 relative">
      <div className="grid md:grid-cols-12 gap-14 md:gap-10 items-center">
        <Reveal className="md:col-span-5 md:col-start-1" y={36}>
          <div className="max-w-[350px] mx-auto md:max-w-none">
            <BookCover />
          </div>
        </Reveal>

        <div className="md:col-span-6 md:col-start-6">
          <Reveal>
            <p className="eyebrow mb-6">The Book</p>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-[0.06em]" data-testid="book-feature-title">
              REGULATE
            </h2>
            <p className="mt-5 font-serif italic text-xl md:text-2xl text-deepteal" data-testid="book-feature-tagline">
              <BookTagline />
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-taupe max-w-lg">
              REGULATE isn’t another book about becoming a better version of
              yourself. It’s an invitation to understand the version of you that
              learned to survive.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Link
                to="/regulate"
                data-testid="book-feature-explore-button"
                className="text-center bg-teal text-ivory text-xs uppercase tracking-[0.25em] px-10 py-4 hover:bg-deepteal transition-colors duration-500"
              >
                Explore REGULATE
              </Link>
              <a
                href={AMAZON_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="book-feature-amazon-button"
                className="inline-flex items-center justify-center gap-2 border border-stone bg-white/60 text-charcoal text-xs uppercase tracking-[0.25em] px-10 py-4 hover:border-teal hover:text-deepteal transition-colors duration-500"
              >
                Buy on Amazon
                <ArrowUpRight size={14} />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default BookFeature;
